import { render, staticRenderFns } from "./FormatHelp.vue?vue&type=template&id=3e16f7c2&scoped=true&"
import script from "./FormatHelp.vue?vue&type=script&lang=js&"
export * from "./FormatHelp.vue?vue&type=script&lang=js&"
import style0 from "./FormatHelp.vue?vue&type=style&index=0&id=3e16f7c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16f7c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e16f7c2')) {
      api.createRecord('3e16f7c2', component.options)
    } else {
      api.reload('3e16f7c2', component.options)
    }
    module.hot.accept("./FormatHelp.vue?vue&type=template&id=3e16f7c2&scoped=true&", function () {
      api.rerender('3e16f7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import/FormatHelp.vue"
export default component.exports